const stats = [
  { num: "128组", label: "本周街拍更新" },
  { num: "46组", label: "机场照归档" },
  { num: "3.6k组", label: "同款生图对比" },
  { num: "早7:00", label: "每天上新时间" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* 稀疏留白 + 细线装饰 */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-background-300 to-transparent"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -left-24 top-24 hidden h-56 w-56 rounded-full bg-accent-100/60 blur-3xl lg:block"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-16 bottom-10 hidden h-64 w-64 rounded-full bg-primary-100/50 blur-3xl lg:block"
      />

      <div className="relative mx-auto max-w-6xl px-4 pb-10 pt-28 md:px-6 md:pb-16 md:pt-36">
        {/* 眉题 */}
        <p className="mb-6 flex items-center gap-3 text-xs font-medium uppercase tracking-widest2 text-primary-600">
          <span className="inline-block h-px w-8 bg-primary-500" />
          街拍 · 私服 · 机场 · 素颜 · 同款穿搭
        </p>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          {/* 文案优先 */}
          <div className="lg:col-span-8">
            <h1 className="font-heading text-4xl font-black leading-[1.12] tracking-tight text-foreground-950 md:text-6xl md:leading-[1.1]">
              镜头里的真实状态，
              <br />
              不修图也好看。
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              吃瓜图集把街头、机场与日常里的私服状态一页页收好：
              <span className="text-foreground-950">街拍照片持续更新</span>
              ，同款穿搭可以一键生图对比。路人视角直出，画面更接近真实。
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#street"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
              >
                开始看图
              </a>
              <a
                href="#topics"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-arrow-right-line text-base" />
                逛逛本周话题
              </a>
              <span className="text-xs text-foreground-500">
                每日早 7:00 · 路人视角直出
              </span>
            </div>
          </div>

          {/* 视觉陪衬：小型竖幅封面 + 说明 */}
          <div className="flex items-end gap-4 lg:col-span-4 lg:justify-end">
            <div className="hidden w-40 lg:block">
              <p className="mb-3 border-b border-background-200 pb-2 text-[11px] uppercase tracking-widest2 text-foreground-400">
                编辑手记
              </p>
              <p className="text-sm leading-relaxed text-foreground-600">
                我们只讲状态与搭配，不追八卦。打开图集，先看这一张。
              </p>
            </div>
            <div className="relative w-40 overflow-hidden rounded-lg md:w-52">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20street%20style%20portrait%20of%20a%20young%20woman%20in%20an%20oversized%20oatmeal%20trench%20coat%20and%20low%20heeled%20boots%2C%20standing%20on%20a%20warm%20sunlit%20sidewalk%2C%20soft%20golden%20hour%20light%2C%20cream%20beige%20palette%2C%20candid%20magazine%20cover%20aesthetic%2C%20clean%20minimal%20composition%2C%20natural%20relaxed%20pose%2C%20fashion%20editorial%20photography&width=700&height=880&seq=hero-feature&orientation=portrait"
                alt="吃瓜图集街拍照片本期首推封面"
                title="吃瓜图集 · 街拍照片"
                className="h-[360px] w-full object-cover object-top md:h-[430px]"
              />
              <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                今日首推
              </span>
            </div>
          </div>
        </div>

        {/* 数字点缀（上疏） */}
        <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-background-50 px-5 py-4">
              <p className="font-heading text-2xl font-bold text-foreground-950">{s.num}</p>
              <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}